<template>
    <div class="advertiser-option product-type" v-if="advertiserLoaded">
        <div class="advertiser-option--title">
        </div>
        <div class="col-md-12">
            <div class="campaign-box">
                <h2>Product Type</h2>

                <ul class="product_type">
                    <li v-for="productType in availableProductTypes">
                        <label>{{ productType.label }}</label>
                        <label><input type="radio" v-model="currentProductTypes[productType.id]" :name="productType.id" v-bind:value="true" :checked="true" /> National</label>
                        <label><input type="radio" v-model="currentProductTypes[productType.id]" :name="productType.id" v-bind:value="false" :checked="!isNational(productType.id)" /> Local</label>
                    </li>

                </ul>

                <button v-on:click="handleUpdate()" type="button" class="btn btn-block --gray --gray-border">Save Product Types</button>
            </div>
        </div>
    </div>
</template>

<style>
    ul.product_type {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    ul.product_type li {
       padding: 5px;
    }
    ul.product_type li label {
        width: 25%;
    }
    ul.product_type li label input[type=radio] {
       margin-right: 20px;
    }
</style>

<script>
export default {
    name: 'product-type-selector',

    props: ['advertiser'],

    data() {
        return {
            availableProductTypes: [
                {"id": "checking", "label": "Checking"},
                {"id": "savings", "label": "Savings"},
                {"id": "certificate of deposit", "label": "CD"},
                {"id": "money market account", "label": "MMA"},
            ],
            currentProductTypes: {},
        }
    },

    computed: {
        advertiserLoaded(){
            return !_.isEmpty(this.advertiser);
        }
    },

    watch: {
        advertiser() {
            var mappedProductTypes = {}
            this.advertiser.product_types.forEach(p => {
               mappedProductTypes[p.id] = (p.isNational == 1);
            });
            this.currentProductTypes = mappedProductTypes;

            this.$emit('input', this.productTypes);
        },
    },

    methods: {
        handleUpdate() {
            this.$emit('selections', this.currentProductTypes);
        },
        isNational(productType) {
            if (this.advertiser.product_type) {
                return this.advertiser.product_types.find(s => (s.id == productType && s.isNational)) !== undefined;
            }

            return false;
        },
    },

    components: {
    }
}
</script>
